import { Swiper } from "../libs/swiper.js";

function initSlider() {
  const progressCircle = document.querySelectorAll(
    ".promo-slider__progress svg"
  );
  const progressCounters = document.querySelectorAll(".promo-slider__count");
  const sliders = document.querySelectorAll("[data-slider]");
  const slidersWithThumb = document.querySelectorAll("[data-slider-thumbs]");
  const slidersWithThumbV2 = document.querySelectorAll(
    "[data-slider-thumbs-v2]"
  );
  const newsDetailSliders = document.querySelectorAll(".news-detail-slider");
  const schedulSwiperElement = document.querySelector(".schedule__swiper");
  const wideSlider = document.querySelector(".slider-wide");
  // const deadlinesSliders = document.querySelectorAll(".deadlines__slider");

  // if (deadlinesSliders) {
  //   deadlinesSliders.forEach((deadlinesSlider) => {
  //     if (!deadlinesSlider.classList.contains("swiper-initialized")) {
  //       new Swiper(deadlinesSlider, {
  //         slidesPerView: "auto",
  //         spaceBetween: 16,
  //         direction: "horizontal",

  //         navigation: {
  //           nextEl: deadlinesSlider.querySelector("[data-slider-next]"),
  //           prevEl: deadlinesSlider.querySelector("[data-slider-prev]"),
  //         },

  //         on: {
  //           init: function () {
  //             updateNavigationButtons(this);
  //           },
  //           slideChange: function () {
  //             updateNavigationButtons(this);
  //           },
  //           reachEnd: function () {
  //             updateNavigationButtons(this);
  //           },
  //           reachBeginning: function () {
  //             updateNavigationButtons(this);
  //           },
  //         },
  //       });

  //       function updateNavigationButtons(deadlinesSliderElement) {
  //         var prevButton = document.querySelector("[data-slider-prev]");
  //         var nextButton = document.querySelector("[data-slider-next]");

  //         if (deadlinesSliderElement.isBeginning) {
  //           prevButton.classList.add("visually-hidden");
  //         } else {
  //           prevButton.classList.remove("visually-hidden");
  //         }

  //         if (deadlinesSliderElement.isEnd) {
  //           nextButton.classList.add("visually-hidden");
  //         } else {
  //           nextButton.classList.remove("visually-hidden");
  //         }
  //       }
  //     }
  //   });
  // }

  if (schedulSwiperElement) {
    let activeSlideIndex;
    document.querySelectorAll(".swiper-slide").forEach((slide, index) => {
      if (slide.querySelector(".schedule-card--active")) {
        activeSlideIndex = index;
      }
    });

    new Swiper(schedulSwiperElement, {
      loop: false,
      initialSlide: activeSlideIndex,
      autoHeight: true,

      navigation: {
        nextEl: ".schedule__box-next",
        prevEl: ".schedule__box-prev",
      },

      spaceBetween: 24,

      on: {
        init: function () {
          updateNavigationButtons(this);
          updateSlideNumbers(this);
        },
        slideChange: function () {
          updateNavigationButtons(this);
          updateSlideNumbers(this);
        },
        reachEnd: function () {
          updateNavigationButtons(this);
        },
        reachBeginning: function () {
          updateNavigationButtons(this);
        },
      },
    });

    function updateNavigationButtons(schedulSwiperElement) {
      var prevButton = document.querySelector(".schedule__box-prev");
      var nextButton = document.querySelector(".schedule__box-next");

      if (schedulSwiperElement.isBeginning) {
        prevButton.classList.add("visually-hidden");
      } else {
        prevButton.classList.remove("visually-hidden");
      }

      if (schedulSwiperElement.isEnd) {
        nextButton.classList.add("visually-hidden");
      } else {
        nextButton.classList.remove("visually-hidden");
      }
    }

    function updateSlideNumbers(schedulSwiperElement) {
      let currentSlide = schedulSwiperElement.realIndex + 1;
      let countElement = document.querySelector(".news-slider__count");
      if (countElement) {
        countElement.textContent = currentSlide;
      }

      let totalSlides = schedulSwiperElement.slides.length;
      let totalElement = document.querySelector(".news-slider__total");
      if (totalElement) {
        totalElement.textContent = totalSlides;
      }
    }
  }

  if (newsDetailSliders) {
    newsDetailSliders.forEach((newsDetailSlider) => {
      if (!newsDetailSlider.classList.contains("swiper-initialized")) {
        new Swiper(newsDetailSlider, {
          loop: false,
          autoHeight: true,

          navigation: {
            nextEl: newsDetailSlider.querySelector("[data-slider-next]"),
            prevEl: newsDetailSlider.querySelector("[data-slider-prev]"),
          },

          pagination: {
            el: newsDetailSlider.querySelector("[data-slider-points]"),
            bulletClass: "life-gallery__point",
            bulletActiveClass: "life-gallery__point--active",
            clickable: false,
          },
        });
      }
    });
  }

  if (document.querySelector(".projects-slider")) {
    function initializeSlider() {
      if (window.innerWidth < 769) {
        document.querySelectorAll(".projects").forEach((projectContainer) => {
          const projectsSlider =
            projectContainer.querySelector(".projects-slider");
          const scrollNext =
            projectContainer.querySelector(".data-slider-next");
          const scrollPrev = projectContainer.querySelector(
            ".slider__button--prev"
          );

          if (scrollNext) {
            scrollNext.addEventListener("click", () => {
              scrollToBlock(projectsSlider);
            });
          }

          if (scrollPrev) {
            scrollPrev.addEventListener("click", () => {
              scrollToBlock(projectsSlider);
            });
          }

          function scrollToBlock(block) {
            block.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      }
    }
    window.addEventListener("resize", initializeSlider);
  }

  if (document.querySelector("#cards-slider")) {
    const cardsSlider = new Swiper("#cards-slider", {
      breakpoints: {
        320: {
          slidesPerView: 1,
          grid: {
            rows: 3,
          },
          spaceBetween: 16,
        },

        1024: {
          grid: {
            rows: 1,
          },
          direction: "horizontal",
          slidesPerView: 3,
          spaceBetween: 22,
        },
      },

      navigation: {
        nextEl: "#cards-slider .cards-slider__button--next",
        prevEl: "#cards-slider .cards-slider__button--prev",
        disabledClass: "cards-slider__button--disabled",
        lockClass: "cards-slider__button--lock",
      },

      pagination: {
        el: ".cards-slider__fraction",
        type: "fraction",
      },
    });
  }
  if (document.querySelectorAll(".live-academy-slider")) {
    document.querySelectorAll(".live-academy-slider").forEach((e) => {
      const cardsSlider = new Swiper(e, {
        slidesPerView: 1,
        navigation: {
          nextEl: ".live-academy-slider__button--next",
          prevEl: ".live-academy-slider__button--prev",
          disabledClass: "live-academy-slider__button--disabled",
          lockClass: "live-academy-slider__button--lock",
        },

        pagination: {
          el: ".live-academy-slider__fraction",
          clickable: true,
        },
      });
    });
  }

  if (document.querySelector("#partners-slider")) {
    const cardsSlider = new Swiper("#partners-slider", {
      breakpoints: {
        320: {
          direction: "horizontal",
          slidesPerView: 2,
          slidesPerGroup: 2,
          grid: {
            rows: 3,
          },
          spaceBetween: 8,
        },
        744: {
          grid: {
            rows: 2,
          },
          direction: "horizontal",
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 48,
        },
        1024: {
          direction: "horizontal",
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 8,
        },
      },
      navigation: {
        nextEl: "#partners-slider .partners-slider__button--next",
        prevEl: "#partners-slider .partners-slider__button--prev",
        disabledClass: "partners-slider__button--disabled",
        lockClass: "partners-slider__button--lock",
      },

      pagination: {
        el: ".partners-slider__fraction",
        type: "fraction",
      },
    });
  }
  if (document.querySelector("#photo-slider")) {
    const photoSlider = new Swiper("#photo-slider", {
      direction: "horizontal",
      autoHeight: true,

      navigation: {
        nextEl: "#photo-slider .photo-slider__button--next",
        prevEl: "#photo-slider .photo-slider__button--prev",
        disabledClass: "photo-slider__button--disabled",
      },

      pagination: {
        el: ".photo-slider__fraction",
        type: "fraction",
      },
    });
  }
  if (document.querySelector("#related-programs-slider")) {
    const relatedProgramsSlider = new Swiper("#related-programs-slider", {
      direction: "horizontal",
      spaceBetween: 20,
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
      },
      autoHeight: true,
      navigation: {
        nextEl: "#related-programs-slider .related-programs__button--next",
        prevEl: "#related-programs-slider .related-programs__button--prev",
        disabledClass: "related-programs__button--disabled",
      },

      pagination: {
        el: ".related-programs__fraction",
        type: "fraction",
      },
    });
  }

  if (document.querySelector(".quotes-slider")) {
    const quotesSlider = new Swiper(".quotes-slider", {
      direction: "horizontal",
      loop: true,
      autoHeight: true,

      navigation: {
        nextEl: ".quotes-slider [data-slider-next]",
        prevEl: ".quotes-slider [data-slider-prev]",
      },
    });

    quotesSlider.on("slideChangeTransitionEnd", function () {
      if (window.innerWidth <= 743) {
        const topPostion =
          document
            .querySelector(".quotes-slider .swiper-slide-active")
            .getBoundingClientRect().top + window.scrollY;
        scrollTo(0, topPostion - 40);
      }
    });
  }

  if (document.querySelector(".nl-promo__slider")) {
    const newsListSlider = new Swiper(".nl-promo__slider", {
      direction: "vertical",
      autoHeight: false,
      slidesPerView: 3,
      spaceBetween: 32,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      resistance: true,
      resistanceRatio: 0,
      speed: 5000,
    });

    if (document.querySelector(".nl-promo").offsetHeight > 600) {
      document.querySelector(
        ".nl-promo .nl-promo__slider"
      ).style.maxHeight = `${
        document.querySelector(".nl-promo").offsetHeight
      }px`;
      document.querySelector(
        ".nl-promo__slider-container"
      ).style.maxHeight = `${
        document.querySelector(".nl-promo").offsetHeight
      }px`;
    }
  }

  if (document.querySelector(".promo-slider")) {
    const promoSwiper = new Swiper(".promo-slider", {
      direction: "horizontal",
      loop: true,

      navigation: {
        nextEl: ".promo-slider__counter--next",
        prevEl: ".promo-slider__counter--prev",
      },

      autoplay: {
        delay: Number(
          document.querySelector(".promo-slider").dataset
            ?.swiperAutoplayDuration || "4000"
        ),
        disableOnInteraction: false,
      },
    });

    promoSwiper.on("transitionEnd", function () {
      progressCounters.forEach((el) => {
        el.innerHTML = promoSwiper.realIndex + 1;
      });
    });

    promoSwiper.on("autoplayTimeLeft", function (swiper, timeLeft, percentage) {
      progressCircle.forEach((el) => {
        el.style.strokeDashoffset = `calc(125.6 + (125.6 * (1 + ${percentage})))`;
      });
    });
  }

  if (document.querySelector(".slider-wide")) {
    const wideSwiper = new Swiper(".slider-wide", {
      direction: "horizontal",
      loop: true,

      navigation: {
        nextEl: ".slider-wide__button--next",
        prevEl: ".slider-wide__button--prev",
      },

      autoplay: {
        delay: Number(wideSlider.dataset?.swiperAutoplayDuration || "4000"),
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
    });
  }

  if (sliders.length) {
    sliders.forEach((slider) => {
      const sliderAutoplayDuration = slider.dataset?.swiperAutoplayDuration;
      if (!slider.classList.contains("swiper-initialized")) {
        const newSlider = new Swiper(slider, {
          direction: "horizontal",
          loop: false,
          init: false,
          autoHeight: true,
          observer: true,

          autoplay: {
            delay: sliderAutoplayDuration
              ? Number(sliderAutoplayDuration || "4000")
              : 600000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          },

          navigation: {
            nextEl: slider.querySelector("[data-slider-next]"),
            prevEl: slider.querySelector("[data-slider-prev]"),
          },
        });

        newSlider.on("update", function () {
          const slidesCount = slider.querySelectorAll(".swiper-slide").length;
          const sliderTotalCounter = slider.querySelector(
            "[data-counter-total]"
          );

          if (slidesCount < 2) {
            slider
              .querySelector(".slider__controls")
              .classList.add("visually-hidden");
            return;
          }

          if (slider.querySelector(".slider__controls")) {
            slider
              .querySelector(".slider__controls")
              .classList.remove("visually-hidden");
          }

          if (sliderTotalCounter) {
            sliderTotalCounter.textContent = slidesCount;
          }

          newSlider.slideTo(0);
        });

        newSlider.on("init", function () {
          const slidesCount = slider.querySelectorAll(".swiper-slide").length;
          const sliderTotalCounter = slider.querySelector(
            "[data-counter-total]"
          );

          if (sliderTotalCounter) {
            sliderTotalCounter.textContent = slidesCount;
          }

          if (slidesCount < 2) {
            if (slider.querySelector(".slider__controls")) {
              slider
                .querySelector(".slider__controls")
                .classList.add("visually-hidden");
              return;
            }
          }
        });

        if (slider.parentNode.querySelector("[data-counter]")) {
          newSlider.on("transitionEnd", function () {
            if (slider.querySelector("[data-counter]")) {
              slider.querySelector("[data-counter]").textContent =
                newSlider.realIndex + 1;
            }

            if (slider.querySelector("[data-slider-prev]")) {
              if (newSlider.realIndex + 1 > 1) {
                slider
                  .querySelector("[data-slider-prev]")
                  .classList.remove("visually-hidden");
              } else {
                slider
                  .querySelector("[data-slider-prev]")
                  .classList.add("visually-hidden");
              }
            }
          });
        } else {
          newSlider.on("transitionEnd", function () {
            if (slider.querySelector("[data-slider-prev]")) {
              if (newSlider.realIndex + 1 > 1) {
                slider
                  .querySelector("[data-slider-prev]")
                  .classList.remove("visually-hidden");
              } else {
                slider
                  .querySelector("[data-slider-prev]")
                  .classList.add("visually-hidden");
              }
            }
          });
        }

        newSlider.init();

        slider.classList.add("swiper-initialized");
      }
    });
  }

  if (slidersWithThumb.length) {
    slidersWithThumb.forEach((slider) => {
      const sliderImages = slider.querySelector("[data-slider-images]");
      const sliderThumbs = slider.querySelector("[data-slider-thumbs]");

      const thumbs2 = new Swiper(sliderThumbs, {
        direction: "horizontal",
        loop: false,
        slidesPerView: 3,
        spaceBetween: 10,
        initialSlide: 0,
        loopedSlides: 1,

        breakpoints: {
          744: {
            direction: "vertical",
            spaceBetween: 16,
          },
          1240: {
            direction: "vertical",
            spaceBetween: 20,
          },
        },
      });

      const gallerySlider = new Swiper(sliderImages, {
        direction: "horizontal",
        loop: false,

        thumbs: {
          swiper: thumbs2,
        },

        navigation: {
          nextEl: slider.querySelector("[data-slider-next]"),
          prevEl: slider.querySelector("[data-slider-prev]"),
        },

        pagination: {
          el: slider.querySelector("[data-slider-points]"),
          bulletClass: "life-gallery__point",
          bulletActiveClass: "life-gallery__point--active",
          clickable: false,
        },
      });

      thumbs2.on("click", function () {
        thumbs2.update();
        thumbs2.slideTo(0);
      });

      gallerySlider.on("slideChange", function () {
        thumbs2.update();
      });
    });
  }

  if (slidersWithThumbV2.length) {
    slidersWithThumbV2.forEach((slider) => {
      const sliderImages = slider.querySelector("[data-slider-images]");
      const sliderThumbs = slider.querySelector("[data-slider-thumbs]");

      const thumbs2 = new Swiper(sliderThumbs, {
        direction: "horizontal",
        loop: false,
        slidesPerView: 4,
        spaceBetween: 10,
        initialSlide: 0,
        loopedSlides: 1,

        breakpoints: {
          744: {
            spaceBetween: 16,
            slidesPerView: 5,
          },
        },
      });

      const gallerySlider = new Swiper(sliderImages, {
        direction: "horizontal",
        loop: false,
        init: false,

        thumbs: {
          swiper: thumbs2,
        },

        navigation: {
          nextEl: slider.querySelector("[data-slider-next]"),
          prevEl: slider.querySelector("[data-slider-prev]"),
        },
      });

      thumbs2.on("click", function () {
        thumbs2.update();
        thumbs2.slideTo(0);
      });

      gallerySlider.on("slideChange", function () {
        thumbs2.update();
      });

      gallerySlider.on("update", function () {
        const slidesCount = slider.querySelectorAll(".swiper-slide").length;
        const sliderTotalCounter = slider.querySelector("[data-counter-total]");

        if (slidesCount < 2) {
          slider
            .querySelector(".slider__bottom")
            .classList.add("visually-hidden");
          return;
        }

        if (slider.querySelector(".slider__bottom")) {
          slider
            .querySelector(".slider__bottom")
            .classList.remove("visually-hidden");
        }

        if (sliderTotalCounter) {
          sliderTotalCounter.textContent = slidesCount;
        }

        gallerySlider.slideTo(0);
      });

      gallerySlider.on("init", function () {
        const slidesCount = slider
          .querySelector("[data-slider-images]")
          .querySelectorAll(".swiper-slide").length;
        const sliderTotalCounter = slider.querySelector("[data-counter-total]");

        if (slidesCount < 2) {
          if (slider.querySelector(".slider__bottom")) {
            slider
              .querySelector(".slider__bottom")
              .classList.add("visually-hidden");
            return;
          }
        }

        if (sliderTotalCounter) {
          sliderTotalCounter.textContent = slidesCount;
        }
      });

      if (slider.parentNode.querySelector("[data-counter]")) {
        gallerySlider.on("transitionEnd", function () {
          if (slider.querySelector("[data-counter]")) {
            slider.querySelector("[data-counter]").textContent =
              gallerySlider.realIndex + 1;
          }

          if (slider.querySelector("[data-slider-prev]")) {
            if (gallerySlider.realIndex + 1 > 1) {
              slider
                .querySelector("[data-slider-prev]")
                .classList.remove("visually-hidden");
            } else {
              slider
                .querySelector("[data-slider-prev]")
                .classList.add("visually-hidden");
            }
          }
        });
      }

      gallerySlider.init();
    });
  }
}

export { initSlider };
